// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".description-items{\n  margin-top:1px;\n  border-top:4px solid #c3dbfc\n}\n.description-items__item{\n  color:#4a5d77;\n  font-size:12px;\n  line-height:16.8px;\n  padding:8px 15px;\n  background-color:#e7edf5;\n  border-top:1px solid #c3dbfc;\n  box-sizing:border-box;\n  overflow:hidden;\n  text-align:center\n}\n.description-items__item:first-child{\n  margin-top:1px\n}\n.description-items__item_even{\n  background-color:#eff5fc\n}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
